export const getUserInfo = () => localStorage.getItem('userInfo');
export const getToken = () => localStorage.getItem('token');
export const setToken = (tokenValue: string) => { localStorage.setItem('token', tokenValue); };
export const removeToken = () => { localStorage.removeItem('token'); };
export const checkAuthentication = () => {
  const token = getToken();
  const result = !!token;
  return result;
};
export const getModules = () => localStorage.getItem('modules');
export const getModuleAll = () => localStorage.getItem('moduleAll');
export const getLocalSubModulePath = () => localStorage.getItem('subModulePath');
export const setLocalSubModulePath = (path: any) => localStorage.setItem('subModulePath', JSON.stringify(path));